@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.shipment-object-container {
  display: flex;
  flex-direction: column;
  background-color: @shipment-object--container--background-color;

  > div {
    display: flex;
  }

  .shipment-object {
    background-color: @shipment-object--background-color;
    box-shadow: 1px 1px 3px @shipment-object--box-shadow-color;
    width: 100%;
    flex-direction: column;
  }
}

.package {
  margin-top: 10px;
}

.multi-package-badge {
  border-radius: 4px;
  padding: 5px 10px;
  background-color: @shipment-object--multi-package-badge--background-color;
  display: inline-block;
  margin-right: 5px;
}

.status-and-context {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid @shipment-object--status--border-color;
}
